import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

export type DashboardCardContentPadding = 'none' | 'sm' | 'md';
export type DashboardCardFooterAlign = 'start' | 'between' | 'end';
export type DashboardCardBadgeVariant = 'solid' | 'soft';

@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule, MatProgressBarModule, MatTooltipModule],
  host: { '[attr.title]': 'null' },
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss'
})
export class DashboardCardComponent {
  @Input({ required: true }) title = '';
  @Input({ required: true }) icon = '';
  @Input() subtitle = '';
  @Input() accentColor = '#1976d2';
  @Input() badge: string | number | null = null;
  @Input() badgeTooltip = '';
  @Input() badgeVariant: DashboardCardBadgeVariant = 'solid';
  @Input() isLoading = false;
  @Input() hasError = false;
  @Input() errorIcon = '';
  @Input() errorMessage = '';
  @Input() retryLabel = 'Reintentar';
  @Input() isEmpty = false;
  @Input() emptyIcon = '';
  @Input() emptyMessage = '';
  @Input() titleLink: unknown[] | string | null = null;
  @Input() titleQueryParams: Record<string, unknown> | null = null;
  @Input() showFooter = false;
  @Input() paddedContent = false;
  @Input() contentPadding: DashboardCardContentPadding = 'none';
  @Input() footerAlign: DashboardCardFooterAlign = 'between';
  @Output() retry = new EventEmitter<void>();

  get resolvedContentPadding(): DashboardCardContentPadding {
    return this.paddedContent && this.contentPadding === 'none' ? 'sm' : this.contentPadding;
  }

  get hasEmptyState(): boolean {
    return this.isEmpty && !this.isLoading && !this.hasError;
  }

  get hasErrorState(): boolean {
    return this.hasError && !this.isLoading;
  }

  get resolvedEmptyIcon(): string {
    return this.emptyIcon || 'info_outline';
  }

  get resolvedEmptyMessage(): string {
    return this.emptyMessage || 'Sin datos para mostrar';
  }

  get resolvedErrorIcon(): string {
    return this.errorIcon || 'cloud_off';
  }

  get resolvedErrorMessage(): string {
    return this.errorMessage || 'No se pudo cargar la información';
  }
}
